/* eslint-disable object-shorthand */
/* eslint-disable func-names */
import { useEffect, useState } from 'react';
import { CognitoUserPool, CognitoUser, AuthenticationDetails, } from 'amazon-cognito-identity-js';
import { PoolData } from '../../config';
import { CHECK_AUTH_TOKEN_TIMING } from '../constants';
import { isTokenExpired, storageHandler } from '../utils';
export const useCognitoAuthenticationWithOptions = ({ cognitoUserPoolConfig = PoolData, browserCacheType = 'localStorage', }) => {
    const [isFetching, setFetching] = useState(false);
    const [authCheckComplete, setAuthCheckComplete] = useState(false);
    const [authToken, setAuthToken] = useState('');
    const [authError, setAuthError] = useState('');
    const userPool = new CognitoUserPool(cognitoUserPoolConfig);
    const authenticateUser = (userName, password) => {
        setFetching(true);
        const userData = { Username: userName, Pool: userPool };
        const authData = { Username: userName, Password: password };
        const cognitoUser = new CognitoUser(userData);
        const authenticationDetails = new AuthenticationDetails(authData);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
                const accessToken = result.getIdToken().getJwtToken();
                setAuthError('');
                setAuthToken(accessToken);
                setAuthCheckComplete(true);
                setFetching(false);
            },
            onFailure: function (err) {
                setAuthError(err.message || JSON.stringify(err));
                setAuthCheckComplete(true);
                setFetching(false);
            },
        });
    };
    useEffect(() => {
        if (authToken) {
            storageHandler(browserCacheType).setAuthToken(authToken);
        }
        else {
            const existingToken = storageHandler(browserCacheType).getAuthToken();
            if (existingToken && !isTokenExpired(existingToken)) {
                storageHandler(browserCacheType).setAuthToken(existingToken);
            }
            else {
                storageHandler(browserCacheType).clean();
            }
        }
    }, [authToken, browserCacheType]);
    // Sets interval to check token expiration and logout user if so.
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let authTokenInterval;
        if (authToken && !authError) {
            authTokenInterval = setInterval(() => {
                const storedToken = storageHandler(browserCacheType).getAuthToken();
                if (storedToken && !isTokenExpired(storedToken)) {
                    storageHandler(browserCacheType).clean();
                }
            }, CHECK_AUTH_TOKEN_TIMING);
        }
        return () => clearInterval(authTokenInterval);
    }, [authToken, authError, browserCacheType]);
    return {
        authCheckComplete,
        authToken,
        authError,
        authenticateUser,
        isFetching,
    };
};
export const useCognitoAuthentication = (cognitoUserPoolConfig = PoolData) => {
    console.warn("WARNING, depreciated hook use 'useCognitoAuthenticationWithOptions' instead.");
    return useCognitoAuthenticationWithOptions({ cognitoUserPoolConfig });
};
//# sourceMappingURL=useCognitoAuthentication.js.map